import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";

// Public Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import WebsitePreview from "./pages/WebsitePreview";
import OrderPage from "./pages/OrderPage";
import PaymentResult from "./pages/PaymentResult";
import GetStartedPage from "./pages/GetStartedPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SiteBySubdomain from "./pages/SiteBySubdomain";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import DashboardStats from "./pages/admin/DashboardStats";
import FindBusinesses from "./pages/admin/FindBusinesses";
import SnoozedBusinesses from "./pages/admin/SnoozedBusinesses";
import Favourites from "./pages/admin/Favourites";
import GeneratedWebsites from "./pages/admin/GeneratedWebsites";
import PreviewSent from "./pages/admin/PreviewSent";
import NoResponse from "./pages/admin/NoResponse";
import WebsiteOrdered from "./pages/admin/WebsiteOrdered";
import LiveWebsites from "./pages/admin/LiveWebsites";
import ApiUsage from "./pages/admin/ApiUsage";
import PostcodeCoverage from "./pages/admin/PostcodeCoverage";
import PostcodeDistricts from "./pages/admin/PostcodeDistricts";
import BlogAdmin from "./pages/admin/BlogAdmin";
import AdminLayout from "./components/AdminLayout";

// Context
import { AuthProvider } from "./context/AuthContext";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/preview/:websiteId" element={<WebsitePreview />} />
          <Route path="/order/:websiteId" element={<OrderPage />} />
          <Route path="/order" element={<PaymentResult />} />
          <Route path="/site/:subdomain" element={<SiteBySubdomain />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardStats />} />
            <Route path="dashboard" element={<DashboardStats />} />
            <Route path="snoozed" element={<SnoozedBusinesses />} />
            <Route path="find" element={<FindBusinesses />} />
            <Route path="favourites" element={<Favourites />} />
            <Route path="websites" element={<GeneratedWebsites />} />
            <Route path="preview-sent" element={<PreviewSent />} />
            <Route path="no-response" element={<NoResponse />} />
            <Route path="ordered" element={<WebsiteOrdered />} />
            <Route path="live" element={<LiveWebsites />} />
            <Route path="api-usage" element={<ApiUsage />} />
            <Route path="coverage" element={<PostcodeCoverage />} />
            <Route path="postcodes" element={<PostcodeDistricts />} />
            <Route path="blog" element={<BlogAdmin />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
